// extracted by mini-css-extract-plugin
export default {"hidden":"ContactList_hidden__POxpn","list":"ContactList_list__7O4vW"};